import { Input } from '@progress/kendo-react-inputs';
import React from 'react';
import { InlineCellProps } from './CustomProps';

const InputCell: React.FC<InlineCellProps> = ({
    field,
    dataItem,
    dataIndex,
    onChange,
    required,
    maxChars,
    title,
    pattern,
    ...props
}) => {
    const handleChange = (e: any) => {
        const item = { ...dataItem, [field!]: e.target.value };
        onChange!({
            dataItem: item,
            syntheticEvent: e.syntheticEvent,
            field: field,
            value: e.target.value,
            dataIndex: dataIndex,
        });
    };

    return (
        <td title={title} className={props.className}>
            {dataItem.inEdit ? (
                <Input
                    {...props}
                    required={required}
                    pattern={pattern}
                    value={dataItem[field!]}
                    onChange={handleChange}
                    maxLength={maxChars}
                />
            ) : (
                <span title={title}>{dataItem[field!]}</span>
            )}
        </td>
    );
};
export default InputCell;
